import { FC } from "react";
import NavigationItem from "./NavigationItem";
import { GUIDE_NAVIGATION, NAVIGATION_DEF } from "data/navigation";

export interface NavProps {
  credential: User
}
const Navigation: FC<NavProps> = ({ credential }) => {
  return (
    <ul className="nc-Navigation hidden lg:flex lg:flex-wrap lg:items-center lg:space-x-1 relative">
      {credential == null ? <div></div> : parseInt(credential?.isGuide) === 1 ?
        GUIDE_NAVIGATION.map((item) => (
          <NavigationItem key={item.id} menuItem={item} />
        ))
        :
        NAVIGATION_DEF.map((item) => (
          <NavigationItem key={item.id} menuItem={item} />
        ))
      }
    </ul>
  );
}

export default Navigation;
